'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'envelope-dot';
var width = 576;
var height = 512;
var aliases = ["envelope-badge"];
var unicode = 'e16f';
var svgPathData = ['M64 122.5C64 107.9 75.9 96 90.5 96L369 96c5.3 41.8 30.5 77.2 65.9 96.5L316.4 279.3c-16.9 12.4-39.9 12.4-56.8 0L74.8 143.8C68 138.8 64 130.9 64 122.5zm0 53.1L240.7 305.1c28.2 20.6 66.5 20.6 94.6 0l135.8-99.6c8.1 1.6 16.4 2.4 24.9 2.4 5.4 0 10.8-.3 16-1l0 177c0 17.7-14.3 32-32 32L96 416c-17.7 0-32-14.3-32-32l0-208.4z', 'M448 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM544 384l0-185.3c-10.1 4.1-20.8 6.9-32 8.3l0 177c0 17.7-14.3 32-32 32L96 416c-17.7 0-32-14.3-32-32l0-208.4 176.7 129.6c28.2 20.6 66.5 20.6 94.6 0l135.8-99.6c-12.9-2.5-25.1-7-36.2-13.1L316.4 279.3c-16.9 12.4-39.9 12.4-56.8 0L74.8 143.8C68 138.8 64 130.9 64 122.5 64 107.9 75.9 96 90.5 96L369 96c-.7-5.2-1-10.6-1-16s.3-10.8 1-16L90.5 64C59 64 33.3 88.9 32.1 120l-.1 0 0 264c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;